<template>
	<div class="" :class="{ selected: selected }">
		<div class="name pt-2">{{ name }}</div>
		<div class="value pb-2">{{ value }}</div>
	</div>
</template>

<script>
/* tslint:disable */

export default {
	name: "Value",
	props: ["name", "value", "selected"],
};
</script>

<style scoped lang="scss">
.name {
	font-size: 0.7em;
	font-family: "Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica,
		sans-serif;
	color: col("colors.DarkGrey");
	text-transform: uppercase;
}
.value {
	font-size: 0.9em;
	font-family: "Source Sans Pro", "Helvetica Neue", Arial, sans-serif;
	font-weight: bold;
}
.selected {
	border-color: col("colors.Secondary");
	background-color: col("colors.Secondary");
	color: col("colors.White");
}

.selected * {
	border-color: col("colors.Secondary");
	background-color: col("colors.Secondary");
	color: col("colors.White");
}
.item:hover {
	border-color: col("colors.Secondary");
	color: col("colors.White");
	background-color: col("colors.Secondary");
	cursor: pointer;
}
.item:hover * {
	color: col("colors.White");
	background-color: col("colors.Secondary");
}
</style>
